import { api } from "../../../api";
import { DeliveryListResponse, RequestDeliveryParams } from "../types";

export async function getDeliveryListApi(
  params: RequestDeliveryParams,
): Promise<DeliveryListResponse> {
  const { data } = await api.get<DeliveryListResponse>(`/api/delivery-info`, {
    params,
  });
  return data;
}

export async function exportDeliveryApi(
  params?: Partial<RequestDeliveryParams>,
): Promise<{
  file: Blob;
  filename: string;
}> {
  const response = await api.get(`/api/delivery-info/export`, {
    params,
    responseType: "blob",
  });
  const disposition = response.headers["content-disposition"];
  let filename = "downloaded_file";
  if (disposition) {
    const match = disposition.match(/filename="?([^"]+)"?/);
    if (match && match[1]) {
      filename = decodeURIComponent(match[1]);
    }
  }

  return { file: response.data, filename };
}
